import initanimation from './components/animation';
import initMobileMenu from './components/MobileMenu';
import quizAnswer from './components/quiz/_quiz-answer';
import quizResult from './components/quiz/quiz-result';
import quizMock from './components/quiz/quiz-mock';
import mockStore from './components/quiz/spi-mock-store';
import spiAdmin from'./components/quiz/spi-admin';
import initPdfViewer from './components/pdf-viewer/pdf-viewer';
import initMediaPopup from './components/media-popup';
/**
 * Main Entry Point
 */
// [[IMPORTS]] <--- ここに import文 が入る

document.addEventListener('DOMContentLoaded', () => {
  console.log('Main.js loaded');

  // [[INITS]] <--- ここに 実行コード が入る

  if (typeof initanimation === 'function') initanimation();
  if (typeof initMobileMenu === 'function') initMobileMenu();
  if (typeof quizAnswer === 'function') quizAnswer();
  if (typeof quizResult === 'function') quizResult();
  if (typeof quizMock === 'function') quizMock();
  if (typeof mockStore === 'function') mockStore();
  if (typeof spiAdmin === 'function') spiAdmin();
  if (typeof initPdfViewer === 'function') initPdfViewer();
  if (typeof initMediaPopup === 'function') initMediaPopup();
});